/**
 * Product Accordion JavaScript
 * Handles accordion toggle functionality
 */

(function() {
  'use strict';

  function initProductAccordion(sectionId) {
    const accordionSection = document.querySelector(`[data-section-id="${sectionId}"]`);
    
    if (!accordionSection) return;

    const accordionItems = accordionSection.querySelectorAll('[data-accordion-item]');
    let activeItem = null;

    // Get settings from data attributes
    const openFirstItem = accordionSection.dataset.openFirstItem === 'true';
    const allowMultipleOpen = accordionSection.dataset.allowMultipleOpen === 'true';

    accordionItems.forEach((item, index) => {
      const header = item.querySelector('[data-accordion-toggle]');
      const content = item.querySelector('[data-accordion-content]');
      
      if (!header || !content) return;

      // Open first item if setting is enabled
      if (openFirstItem && index === 0) {
        header.setAttribute('aria-expanded', 'true');
        content.setAttribute('data-active', 'true');
        activeItem = item;
      }

      header.addEventListener('click', function() {
        const isExpanded = header.getAttribute('aria-expanded') === 'true';
        
        if (isExpanded) {
          // Close current item
          header.setAttribute('aria-expanded', 'false');
          content.setAttribute('data-active', 'false');
          if (activeItem === item) {
            activeItem = null;
          }
        } else {
          // Close previously active item if only one should be open
          if (!allowMultipleOpen && activeItem && activeItem !== item) {
            const prevHeader = activeItem.querySelector('[data-accordion-toggle]');
            const prevContent = activeItem.querySelector('[data-accordion-content]');
            if (prevHeader) prevHeader.setAttribute('aria-expanded', 'false');
            if (prevContent) prevContent.setAttribute('data-active', 'false');
          }
          
          // Open clicked item
          header.setAttribute('aria-expanded', 'true');
          content.setAttribute('data-active', 'true');
          activeItem = item;
        }
      });
    });
  }

  // Initialize all accordion sections on page load
  function initAllAccordions() {
    // Handle sections (legacy)
    const accordionSections = document.querySelectorAll('[data-section-type="product-accordion"]');
    accordionSections.forEach(section => {
      const sectionId = section.dataset.sectionId;
      if (sectionId) {
        initProductAccordion(sectionId);
      }
    });
    
    // Handle blocks (new structure)
    const accordionBlocks = document.querySelectorAll('.product-accordion-block:not([data-accordion-initialized])');
    accordionBlocks.forEach(block => {
      // Mark as initialized to prevent duplicate event listeners
      block.setAttribute('data-accordion-initialized', 'true');
      
      const container = block.querySelector('.product-accordion__container');
      if (!container) return;
      
      const openFirstItem = container.dataset.openFirstItem === 'true';
      const allowMultipleOpen = container.dataset.allowMultipleOpen === 'true';
      
      const accordionItems = container.querySelectorAll('[data-accordion-item]');
      let activeItem = null;

      accordionItems.forEach((item, index) => {
        const header = item.querySelector('[data-accordion-toggle]');
        const content = item.querySelector('[data-accordion-content]');
        
        if (!header || !content) return;

        // Set initial state
        if (openFirstItem && index === 0) {
          header.setAttribute('aria-expanded', 'true');
          content.setAttribute('data-active', 'true');
          activeItem = item;
        } else {
          header.setAttribute('aria-expanded', 'false');
          content.setAttribute('data-active', 'false');
        }

        // Add click handler
        header.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const isExpanded = header.getAttribute('aria-expanded') === 'true';
          
          if (isExpanded) {
            // Close current item
            header.setAttribute('aria-expanded', 'false');
            content.setAttribute('data-active', 'false');
            if (activeItem === item) {
              activeItem = null;
            }
          } else {
            // Close previously active item if only one should be open
            if (!allowMultipleOpen && activeItem && activeItem !== item) {
              const prevHeader = activeItem.querySelector('[data-accordion-toggle]');
              const prevContent = activeItem.querySelector('[data-accordion-content]');
              if (prevHeader) prevHeader.setAttribute('aria-expanded', 'false');
              if (prevContent) prevContent.setAttribute('data-active', 'false');
            }
            
            // Open clicked item
            header.setAttribute('aria-expanded', 'true');
            content.setAttribute('data-active', 'true');
            activeItem = item;
          }
        });
      });
    });
  }

  // Initialize on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllAccordions);
  } else {
    initAllAccordions();
  }

  // Re-initialize when section/block is loaded via AJAX (theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const section = event.detail.sectionId;
      if (section) {
        setTimeout(() => {
          initProductAccordion(section);
          initAllAccordions(); // Re-init blocks as well
        }, 100);
      }
    });

    // Re-initialize when block is loaded
    document.addEventListener('shopify:block:select', function(event) {
      setTimeout(() => {
        initAllAccordions();
      }, 100);
    });
  }
})();

